export default __webpack_public_path__ + "static/media/linux.c3fefe50.svg";